/**
 * SymbolTable.js
 * Description: renders a table of identifier-value pair
 */

import { useContext } from "react";

import {
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";

import { context } from "../context/GlobalState";

const SymbolTable = () => {
  const { state } = useContext(context);
  const identifiers = state.symbolTable;
  return (
    <Table variant="striped" colorScheme="blue">
      <Thead>
        <Tr>
          <Th>Identifier</Th>
          <Th>Value</Th>
        </Tr>
      </Thead>
      <Tbody>
        {Object.keys(identifiers).map((ident, idx) => (
          <Tr key={idx}>
            <Td>{ident}</Td>
            <Td>
              {identifiers[ident] ? identifiers[ident].toString() : "null"}
            </Td>
          </Tr>
        ))}
      </Tbody>
      <TableCaption flex={1}>
        Symbol table stores tokens and more information about the token.
      </TableCaption>
    </Table>
  );
};

export default SymbolTable;
